// SEO Content: Köln Stadtteile Teil 3
// Bayenthal, Marienburg, Neustadt, Altstadt, Braunsfeld und weitere

const seoContentKoeln3 = {
  // Stadtteil: Bayenthal
  bayenthal: {
    heroTitle: "Maler in Köln-Bayenthal – Südstadt-Eleganz am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten im gehobenen Bayenthal. Ihr Partner für Altbau und exklusive Wohnungen.",

    mainContent: {
      intro: `Bayenthal gehört zu den feinsten Adressen der Kölner Südstadt. Der Stadtteil zwischen Rheinufer und Militärring besticht durch seine großzügige Gründerzeitbebauung und die Nähe zum Wasser. Hier wohnt, wer Wert auf Qualität, Ruhe und zentrale Lage legt.

Als Malerbetrieb sind wir regelmäßig in Bayenthal tätig. Die anspruchsvollen Altbauwohnungen und gepflegten Häuser hier fordern unser Können – und genau das macht die Arbeit hier besonders.`,

      localExpertise: `Bayenthal ist geprägt von Gründerzeitbauten mit großzügigen Grundrissen und hohen Decken. Die Wohnungen haben oft noch original Stuckdecken, Kassettentüren und Parkettböden. Diese Details verdienen eine sorgfältige Behandlung.

Die Bebauung ist überwiegend mehrgeschossig, aber nicht zu dicht. Große Bäume, gepflegte Vorgärten und breite Straßen prägen das Erscheinungsbild. Wer hier wohnt, achtet auf sein Umfeld – und erwartet das auch von Handwerkern.

Die Nähe zum Rhein und zum Südpark macht Bayenthal besonders attraktiv. Die Rheinlage bringt aber auch besondere Anforderungen für Fassaden mit sich.`,

      services: `Unser Angebot für Bayenthal:

- **Altbauwohnungen**: Höchste Qualität für historische Substanz
- **Stuckarbeiten**: Restaurierung und Ergänzung von Deckenstuck
- **Fassaden**: Wetterfeste Lösungen für die Rheinlage
- **Treppenhäuser**: Repräsentative Gestaltung für Mehrfamilienhäuser
- **Lackierarbeiten**: Aufarbeitung von Kassettentüren und Fenstern`,

      whyUs: `In Bayenthal erwarten Kunden das Beste – und das liefern wir. Unsere Arbeit hier ist unsere Visitenkarte für die gesamte Südstadt.`
    },

    faq: [
      { question: "Haben Sie Erfahrung mit Stuckdecken?", answer: "Ja, Stuckrestaurierung gehört zu unserem Leistungsspektrum. Wir arbeiten in Bayenthal regelmäßig an historischen Details." },
      { question: "Wie gehen Sie mit der Rheinlage um?", answer: "Wir verwenden feuchtigkeitsbeständige Materialien und achten auf gründliche Untergrundvorbereitung." }
    ],

    nearbyAreas: [{ name: "Marienburg", slug: "marienburg" }, { name: "Neustadt-Süd", slug: "neustadt-sued" }, { name: "Rodenkirchen", slug: "rodenkirchen" }, { name: "Raderberg", slug: "raderberg" }],

    meta: {
      title: "Maler Köln-Bayenthal | Altbau & Südstadt | FarbWelt Service",
      description: "Ihr Maler in Bayenthal ✓ Altbau ✓ Stuck ✓ Rheinlage. Premium-Malerarbeiten in der Südstadt!",
      keywords: "Maler Bayenthal, Maler Köln-Bayenthal, Altbau Südstadt Köln"
    }
  },

  // Stadtteil: Marienburg
  marienburg: {
    heroTitle: "Maler in Köln-Marienburg – Villen und Exklusivität",
    heroSubtitle: "Professionelle Malerarbeiten in Kölns vornehmster Wohnlage. Ihr Spezialist für Villen und Repräsentation.",

    mainContent: {
      intro: `Marienburg ist die exklusivste Adresse Kölns. Die Villenkolonie südlich des Volksgartens beherbergt einige der teuersten und schönsten Häuser der Stadt. Hier wohnen Unternehmer, Prominente und alteingesessene Kölner Familien. Diskrete Eleganz ist das Markenzeichen.

Als Malerbetrieb arbeiten wir in Marienburg mit besonderer Sorgfalt. Die Projekte hier sind anspruchsvoll – und genau das motiviert uns zu Höchstleistungen.`,

      localExpertise: `Marienburg ist geprägt von Villen verschiedener Epochen. Gründerzeitvillen neben Jugendstilhäusern, Bauhausarchitektur neben modernen Neubauten. Jedes Haus ist ein Unikat und verdient individuelle Behandlung.

Die Ansprüche in Marienburg sind hoch – zu Recht. Hier erwarten Kunden perfekte Ausführung, diskrete Abwicklung und erstklassigen Service. Zeitdruck kennt man hier nicht – wichtiger ist das optimale Ergebnis.

Viele Häuser in Marienburg stehen unter Denkmalschutz. Das erfordert besondere Materialien und Abstimmung mit den Behörden. Wir haben Erfahrung mit diesen Anforderungen.`,

      services: `Unser Angebot für Marienburg:

- **Villen komplett**: Innen und außen, mit allen Details
- **Denkmalschutz**: Erfahrung mit Auflagen und zugelassenen Materialien
- **Sonderleistungen**: Vergoldung, Marmorierung, Spezialfinishes
- **Fassadensanierung**: Repräsentative Erscheinung für Ihr Haus
- **Diskrete Abwicklung**: Professionell und vertraulich`,

      whyUs: `In Marienburg muss alles stimmen. Wir verstehen die Erwartungen und erfüllen sie – mit Kompetenz, Diskretion und Liebe zum Detail.`
    },

    faq: [
      { question: "Arbeiten Sie diskret?", answer: "Ja, Diskretion ist in Marienburg selbstverständlich. Wir arbeiten professionell und vertraulich." },
      { question: "Haben Sie Erfahrung mit Denkmalschutz?", answer: "Ja, wir kennen die Auflagen und zugelassenen Materialien für denkmalgeschützte Villen." }
    ],

    nearbyAreas: [{ name: "Bayenthal", slug: "bayenthal" }, { name: "Raderberg", slug: "raderberg" }, { name: "Rodenkirchen", slug: "rodenkirchen" }],

    meta: {
      title: "Maler Köln-Marienburg | Villen & Exklusiv | FarbWelt Service",
      description: "Ihr Maler in Marienburg ✓ Villen ✓ Denkmalschutz ✓ Premium. Exklusive Malerarbeiten für höchste Ansprüche!",
      keywords: "Maler Marienburg, Maler Köln-Marienburg, Villa streichen Köln"
    }
  },

  // Stadtteil: Neustadt-Nord
  "neustadt-nord": {
    heroTitle: "Maler in Köln-Neustadt-Nord – Belgisches Viertel & Mediapark",
    heroSubtitle: "Professionelle Malerarbeiten im angesagten Belgischen Viertel. Ihr Partner für Altbau und moderne Lofts.",

    mainContent: {
      intro: `Die Neustadt-Nord ist einer der vielfältigsten Stadtteile Kölns. Das Belgische Viertel mit seinen hippen Cafés und Boutiquen, der moderne Mediapark mit seinen Bürotürmen und die Gründerzeitviertel rund um den Friesenplatz – hier trifft alles aufeinander.

Als Malerbetrieb sind wir in der Neustadt-Nord besonders gefragt. Die Mischung aus jungen Kreativen, Medienleuten und Alteingesessenen sorgt für abwechslungsreiche Projekte.`,

      localExpertise: `Das Belgische Viertel ist legendär. Die nach belgischen Städten benannten Straßen – Brüsseler, Antwerpener, Lütticher – beherbergen einige der schönsten Altbauwohnungen Kölns. Hohe Decken, Stuck, große Fenster – hier ist Wohnen ein Erlebnis.

Der Mediapark bildet einen Kontrast: moderne Architektur, offene Grundrisse, zeitgemäßes Design. Hier arbeiten wir anders als im Altbau – aber mit dem gleichen Anspruch an Qualität.

Die Kunden in der Neustadt-Nord sind anspruchsvoll und stilbewusst. Sie wissen, was sie wollen – und erwarten, dass wir es umsetzen.`,

      services: `Unser Angebot für Neustadt-Nord:

- **Belgisches Viertel**: Altbausanierung auf höchstem Niveau
- **Mediapark**: Moderne Gestaltung für Büros und Lofts
- **Kreative Konzepte**: Individuelle Farbgestaltung für besondere Räume
- **Ladenlokale**: Boutiquen und Cafés professionell renovieren
- **Express-Service**: Schnelle Renovierung bei Mieterwechsel`,

      whyUs: `In der Neustadt-Nord verstehen wir den Anspruch. Wir sind nicht nur Handwerker, sondern Partner für Ihre Gestaltungsideen.`
    },

    faq: [
      { question: "Kennen Sie das Belgische Viertel gut?", answer: "Ja, wir arbeiten regelmäßig in den Altbauten rund um die Brüsseler Straße." },
      { question: "Können Sie auch besondere Farbkonzepte umsetzen?", answer: "Ja, kreative Gestaltung ist eine unserer Stärken." }
    ],

    nearbyAreas: [{ name: "Neustadt-Süd", slug: "neustadt-sued" }, { name: "Altstadt-Nord", slug: "altstadt-nord" }, { name: "Ehrenfeld", slug: "ehrenfeld" }, { name: "Nippes", slug: "nippes" }],

    meta: {
      title: "Maler Köln-Neustadt-Nord | Belgisches Viertel | FarbWelt Service",
      description: "Ihr Maler in der Neustadt-Nord ✓ Belgisches Viertel ✓ Mediapark ✓ Altbau. Malerarbeiten mit Stil!",
      keywords: "Maler Neustadt-Nord, Maler Belgisches Viertel Köln, Altbau Brüsseler Straße"
    }
  },

  // Stadtteil: Neustadt-Süd
  "neustadt-sued": {
    heroTitle: "Maler in Köln-Neustadt-Süd – Die legendäre Südstadt",
    heroSubtitle: "Professionelle Malerarbeiten in der Kölner Südstadt. Ihr Spezialist für Altbau, Severinsviertel und Rheinauhafen.",

    mainContent: {
      intro: `Die Neustadt-Süd ist die legendäre Kölner Südstadt. Das Severinsviertel mit seinen Kneipen und Brauhäusern, die eleganten Straßen rund um die Severinskirche, der moderne Rheinauhafen mit seinen Kranhäusern – hier ist Köln besonders lebenswert.

Als Malerbetrieb kennen wir die Südstadt aus zahllosen Projekten. Die Mischung aus kölscher Tradition und modernem Lifestyle macht die Arbeit hier besonders interessant.`,

      localExpertise: `Die Südstadt ist Gründerzeit pur. Prächtige Mehrfamilienhäuser mit aufwendigen Fassaden, großzügigen Wohnungen und historischen Details. Hier hat Köln seinen Charakter bewahrt – und wir helfen dabei, ihn zu erhalten.

Der Rheinauhafen ist der moderne Kontrapunkt. In den umgebauten Lagerhäusern und den neuen Kranhäusern treffen wir auf zeitgenössische Architektur und anspruchsvolle Kunden.

Die Südstädter sind ein besonderes Völkchen. Stolz auf ihr Viertel, kritisch gegenüber schlechter Arbeit, aber herzlich, wenn man überzeugt. Wir haben viele Stammkunden hier.`,

      services: `Unser Angebot für die Südstadt:

- **Altbauwohnungen**: Die Gründerzeitbauten sind unsere Spezialität
- **Severinsviertel**: Gaststätten und Geschäftsräume mit Tradition
- **Rheinauhafen**: Moderne Gestaltung für Lofts und Apartments
- **Fassaden**: Aufwendige Gründerzeitfassaden fachgerecht sanieren
- **Treppenhäuser**: Gemeinschaftsprojekte für Eigentümergemeinschaften`,

      whyUs: `In der Südstadt sind wir fast schon Nachbarn. Wir kennen das Viertel, verstehen die Menschen und liefern die Qualität, die hier erwartet wird.`
    },

    faq: [
      { question: "Haben Sie Erfahrung mit den Südstädter Altbauten?", answer: "Ja, wir arbeiten seit Jahren in der Südstadt und kennen die typischen Gründerzeitbauten sehr gut." },
      { question: "Arbeiten Sie auch im Rheinauhafen?", answer: "Ja, die modernen Wohnungen und Lofts im Rheinauhafen gehören zu unserem Portfolio." }
    ],

    nearbyAreas: [{ name: "Altstadt-Süd", slug: "altstadt-sued" }, { name: "Bayenthal", slug: "bayenthal" }, { name: "Neustadt-Nord", slug: "neustadt-nord" }, { name: "Sülz", slug: "suelz" }],

    meta: {
      title: "Maler Köln-Südstadt | Severinsviertel & Rheinauhafen | FarbWelt",
      description: "Ihr Maler in der Südstadt ✓ Severinsviertel ✓ Rheinauhafen ✓ Altbau. Malerarbeiten im Herzen Kölns!",
      keywords: "Maler Südstadt Köln, Maler Neustadt-Süd, Severinsviertel Maler"
    }
  },

  // Stadtteil: Altstadt-Nord
  "altstadt-nord": {
    heroTitle: "Maler in Köln-Altstadt-Nord – Am Fuße des Doms",
    heroSubtitle: "Professionelle Malerarbeiten in der historischen Altstadt. Ihr Partner für Denkmalschutz und Tradition.",

    mainContent: {
      intro: `Die Altstadt-Nord ist das Herz von Köln. Hier steht der Dom, hier beginnt die Hohe Straße, hier pulsiert das Leben. Die engen Gassen, die historischen Brauhäuser und die Mischung aus Tourismus und echtem Kölner Leben machen diesen Stadtteil einzigartig.

Als Malerbetrieb arbeiten wir in der Altstadt mit besonderer Sorgfalt. Geschichte verpflichtet – und wir nehmen diese Verpflichtung ernst.`,

      localExpertise: `Die Altstadt-Nord ist geprägt von Wiederaufbau und Geschichte. Viele Gebäude sind nach dem Krieg neu entstanden, aber im historischen Stil. Echte Altbauten sind selten und kostbar. Was alle verbindet: der Anspruch, das Erscheinungsbild der Altstadt zu bewahren.

Denkmalschutz ist hier allgegenwärtig. Viele Fassaden dürfen nur mit bestimmten Farben und Materialien behandelt werden. Wir kennen diese Auflagen und arbeiten entsprechend.

Die besondere Herausforderung: Die Altstadt ist immer belebt. Malerarbeiten müssen oft außerhalb der Hauptverkehrszeiten erfolgen.`,

      services: `Unser Angebot für die Altstadt-Nord:

- **Denkmalschutz**: Erfahrung mit allen Auflagen und Materialien
- **Gaststätten**: Brauhäuser und Restaurants mit Tradition
- **Geschäftsräume**: Flexible Zeiten für minimale Störung
- **Fassaden**: Historische Erscheinung bewahren
- **Wohnungen**: Seltene Altbauwohnungen mit besonderer Sorgfalt`,

      whyUs: `In der Altstadt arbeiten wir mit Respekt vor der Geschichte. Jedes Projekt hier ist auch ein Beitrag zum Erhalt des Kölner Erbes.`
    },

    faq: [
      { question: "Haben Sie Erfahrung mit Denkmalschutz?", answer: "Ja, wir kennen die Auflagen und arbeiten regelmäßig in der historischen Altstadt." },
      { question: "Arbeiten Sie auch in Brauhäusern?", answer: "Ja, wir haben mehrere traditionelle Gaststätten renoviert." }
    ],

    nearbyAreas: [{ name: "Altstadt-Süd", slug: "altstadt-sued" }, { name: "Neustadt-Nord", slug: "neustadt-nord" }, { name: "Deutz", slug: "deutz" }],

    meta: {
      title: "Maler Köln-Altstadt-Nord | Dom & Denkmalschutz | FarbWelt Service",
      description: "Ihr Maler in der Altstadt-Nord ✓ Denkmalschutz ✓ Tradition ✓ Historie. Malerarbeiten am Kölner Dom!",
      keywords: "Maler Altstadt Köln, Maler Köln-Altstadt-Nord, Denkmalschutz Maler Köln"
    }
  },

  // Stadtteil: Altstadt-Süd
  "altstadt-sued": {
    heroTitle: "Maler in Köln-Altstadt-Süd – Heumarkt und Rheinufer",
    heroSubtitle: "Professionelle Malerarbeiten zwischen Heumarkt und Malakoff-Turm. Ihr Partner für historische und moderne Projekte.",

    mainContent: {
      intro: `Die Altstadt-Süd verbindet Geschichte mit Moderne. Der Heumarkt mit dem Reiterstandbild, das Schokoladenmuseum, die Rheinpromenade – hier ist Köln besonders vielfältig. Und mittendrin: Wohnungen, Geschäfte und Büros, die unsere Arbeit brauchen.

Als Malerbetrieb schätzen wir die Abwechslung in der Altstadt-Süd. Historische Substanz neben modernen Bauten – das hält uns auf Trab.`,

      localExpertise: `Die Altstadt-Süd ist geprägt vom Rheinufer und den angrenzenden Straßen. Hier stehen repräsentative Gebäude neben Wohnhäusern, Museen neben Büros. Die Mischung erfordert Flexibilität.

Am Rheinufer ist die Lage besonders – und bringt besondere Anforderungen mit. Feuchtigkeit vom Fluss, Hochwassergefahr, Tourismus – all das prägt die Arbeitsbedingungen.

Die Heumarkt-Gegend ist geschäftig. Hotels, Restaurants und Geschäfte müssen oft kurzfristig oder außerhalb der Öffnungszeiten renoviert werden.`,

      services: `Unser Angebot für die Altstadt-Süd:

- **Hotels & Gastronomie**: Flexible Arbeitszeiten, schnelle Abwicklung
- **Rheinufer-Immobilien**: Feuchtigkeitsbeständige Lösungen
- **Geschäftsräume**: Angepasst an Touristenströme und Öffnungszeiten
- **Wohnungen**: Gehobene Qualität für zentrale Lagen
- **Fassaden**: Stadtbildprägende Gebäude fachgerecht behandeln`,

      whyUs: `In der Altstadt-Süd sind wir Profis für besondere Herausforderungen. Enge Termine, hohe Frequenz, anspruchsvolle Kunden – das meistern wir.`
    },

    faq: [
      { question: "Arbeiten Sie auch in Hotels und Restaurants?", answer: "Ja, Gastronomie und Hotellerie gehören zu unseren Spezialgebieten in der Altstadt." },
      { question: "Wie gehen Sie mit dem Touristenandrang um?", answer: "Wir planen Arbeiten außerhalb der Stoßzeiten und arbeiten sauber und schnell." }
    ],

    nearbyAreas: [{ name: "Altstadt-Nord", slug: "altstadt-nord" }, { name: "Neustadt-Süd", slug: "neustadt-sued" }, { name: "Bayenthal", slug: "bayenthal" }],

    meta: {
      title: "Maler Köln-Altstadt-Süd | Heumarkt & Rhein | FarbWelt Service",
      description: "Ihr Maler in der Altstadt-Süd ✓ Rheinufer ✓ Hotels ✓ Gastronomie. Malerarbeiten im Kölner Zentrum!",
      keywords: "Maler Altstadt-Süd Köln, Maler Heumarkt, Rheinufer Maler Köln"
    }
  },

  // Weitere Stadtteile (kompakt)
  raderberg: {
    heroTitle: "Maler in Köln-Raderberg – Ihr Nachbar im Süden",
    heroSubtitle: "Professionelle Malerarbeiten im ruhigen Raderberg. Ihr lokaler Malerbetrieb.",
    mainContent: {
      intro: `Raderberg ist ein ruhiger Wohnstadtteil im Kölner Süden. Zwischen den lebhaften Vierteln Bayenthal und Zollstock liegt Raderberg fast verborgen. Die Mischung aus Einfamilienhäusern und kleineren Mehrfamilienhäusern macht das Viertel zum idealen Wohnort für Familien.`,
      localExpertise: `Raderberg ist überschaubar und familiär. Die Bewohner kennen sich, man grüßt sich auf der Straße. Als Malerbetrieb passen wir in diese Atmosphäre: persönlich, zuverlässig, verbindlich.`,
      services: `Unser Angebot umfasst alle Malerarbeiten für Privathaushalte: Innenanstriche, Fassaden, Lackierungen und Tapezierarbeiten.`
    },
    faq: [{ question: "Sind Sie in Raderberg bekannt?", answer: "Ja, wir haben hier Stammkunden und werden weiterempfohlen." }],
    nearbyAreas: [{ name: "Bayenthal", slug: "bayenthal" }, { name: "Zollstock", slug: "zollstock" }, { name: "Marienburg", slug: "marienburg" }],
    meta: { title: "Maler Köln-Raderberg | Ihr Nachbar | FarbWelt Service", description: "Ihr Maler in Raderberg ✓ Persönlich ✓ Zuverlässig ✓ Lokal.", keywords: "Maler Raderberg, Maler Köln-Raderberg" }
  },

  raderthal: {
    heroTitle: "Maler in Köln-Raderthal – Qualität am Grüngürtel",
    heroSubtitle: "Professionelle Malerarbeiten in Raderthal. Ihr Malerbetrieb für Eigenheime und Wohnungen.",
    mainContent: {
      intro: `Raderthal liegt am Äußeren Grüngürtel und bietet Wohnen im Grünen mit guter Stadtanbindung. Die Bebauung ist gemischt: Einfamilienhäuser, Reihenhäuser und einige Mehrfamilienhäuser.`,
      localExpertise: `In Raderthal schätzen Kunden solide Arbeit zu fairen Preisen. Die Nähe zum Grüngürtel macht das Viertel attraktiv für Familien und Naturliebhaber.`,
      services: `Innenanstriche, Fassadenarbeiten, Renovierungen – alles aus einer Hand.`
    },
    faq: [{ question: "Arbeiten Sie am Grüngürtel?", answer: "Ja, Raderthal und Umgebung gehören zu unserem Einzugsgebiet." }],
    nearbyAreas: [{ name: "Raderberg", slug: "raderberg" }, { name: "Zollstock", slug: "zollstock" }, { name: "Klettenberg", slug: "klettenberg" }],
    meta: { title: "Maler Köln-Raderthal | Grüngürtel | FarbWelt Service", description: "Ihr Maler in Raderthal ✓ Eigenheim ✓ Grüngürtel.", keywords: "Maler Raderthal, Maler Köln-Raderthal" }
  },

  zollstock: {
    heroTitle: "Maler in Köln-Zollstock – Zwischen Südstadt und Grüngürtel",
    heroSubtitle: "Professionelle Malerarbeiten im vielseitigen Zollstock. Vom Altbau bis zum Neubau.",
    mainContent: {
      intro: `Zollstock verbindet das Beste aus verschiedenen Welten: städtisches Leben mit Südstadt-Flair, grüne Ruhezonen am Vorgebirgspark und eine gute Mischung verschiedener Wohnformen.`,
      localExpertise: `Zollstock ist vielfältig. Altbauten aus der Gründerzeit, Nachkriegsbauten und moderne Neubauprojekte – wir kennen alle Gebäudetypen und ihre Anforderungen.`,
      services: `Komplettes Malerhandwerk: Innen, außen, Renovierung, Tapezieren, Lackieren.`
    },
    faq: [{ question: "Kennen Sie die verschiedenen Gebäudetypen in Zollstock?", answer: "Ja, von Gründerzeit bis Neubau haben wir hier Erfahrung." }],
    nearbyAreas: [{ name: "Sülz", slug: "suelz" }, { name: "Klettenberg", slug: "klettenberg" }, { name: "Raderberg", slug: "raderberg" }, { name: "Neustadt-Süd", slug: "neustadt-sued" }],
    meta: { title: "Maler Köln-Zollstock | Vielseitig | FarbWelt Service", description: "Ihr Maler in Zollstock ✓ Altbau ✓ Neubau ✓ Alles.", keywords: "Maler Zollstock, Maler Köln-Zollstock" }
  },

  riehl: {
    heroTitle: "Maler in Köln-Riehl – Am Zoo und am Rhein",
    heroSubtitle: "Professionelle Malerarbeiten in Riehl. Ihr lokaler Malerbetrieb.",
    mainContent: {
      intro: `Riehl liegt zwischen dem Kölner Zoo und dem Rhein. Der Stadtteil bietet eine interessante Mischung aus Wohnen, Freizeit und Natur. Die Flora, der Zoo und das Rheinufer machen Riehl besonders attraktiv.`,
      localExpertise: `In Riehl gibt es verschiedene Gebäudetypen – von älteren Wohnhäusern bis zu Neubauten am Rhein. Wir kennen die örtlichen Gegebenheiten.`,
      services: `Alle Malerarbeiten für Privat und Gewerbe – zuverlässig und kompetent.`
    },
    faq: [{ question: "Arbeiten Sie auch in der Nähe des Zoos?", answer: "Ja, Riehl gehört vollständig zu unserem Einzugsgebiet." }],
    nearbyAreas: [{ name: "Nippes", slug: "nippes" }, { name: "Mülheim", slug: "muelheim" }, { name: "Neustadt-Nord", slug: "neustadt-nord" }],
    meta: { title: "Maler Köln-Riehl | Zoo & Rhein | FarbWelt Service", description: "Ihr Maler in Riehl ✓ Lokal ✓ Zuverlässig.", keywords: "Maler Riehl, Maler Köln-Riehl" }
  },

  neuehrenfeld: {
    heroTitle: "Maler in Köln-Neuehrenfeld – Kreativ und Lebendig",
    heroSubtitle: "Professionelle Malerarbeiten im aufstrebenden Neuehrenfeld.",
    mainContent: {
      intro: `Neuehrenfeld ist das Bindeglied zwischen Ehrenfeld und Nippes. Der Stadtteil entwickelt sich dynamisch und zieht junge Menschen und Familien an.`,
      localExpertise: `Die Bebauung ist typisch für Kölner Arbeiterviertel: Gründerzeitbauten, solide und charmant. Wir kennen diese Häuser und wissen, worauf es ankommt.`,
      services: `Altbausanierung, Renovierung, kreative Wandgestaltung – wir setzen Ihre Ideen um.`
    },
    faq: [{ question: "Haben Sie Erfahrung mit Altbauten in Neuehrenfeld?", answer: "Ja, die typischen Gründerzeitbauten sind unser Spezialgebiet." }],
    nearbyAreas: [{ name: "Ehrenfeld", slug: "ehrenfeld" }, { name: "Nippes", slug: "nippes" }, { name: "Bickendorf", slug: "bickendorf" }],
    meta: { title: "Maler Köln-Neuehrenfeld | Kreativ | FarbWelt Service", description: "Ihr Maler in Neuehrenfeld ✓ Altbau ✓ Kreativ.", keywords: "Maler Neuehrenfeld, Maler Köln-Neuehrenfeld" }
  },

  bickendorf: {
    heroTitle: "Maler in Köln-Bickendorf – Bodenständig und Zuverlässig",
    heroSubtitle: "Professionelle Malerarbeiten in Bickendorf. Ihr Malerbetrieb vor Ort.",
    mainContent: {
      intro: `Bickendorf ist ein bodenständiges Wohnviertel im Kölner Westen. Hier leben Familien und Alteingesessene, die Wert auf Qualität und faire Preise legen.`,
      localExpertise: `Die Bebauung ist gemischt: ältere Mehrfamilienhäuser, Siedlungen und neuere Bauten. Wir kennen die Anforderungen aller Gebäudetypen.`,
      services: `Komplette Malerarbeiten – innen und außen, für Privat und Gewerbe.`
    },
    faq: [{ question: "Bieten Sie faire Preise?", answer: "Ja, gute Qualität zu fairen Preisen ist unser Versprechen." }],
    nearbyAreas: [{ name: "Ehrenfeld", slug: "ehrenfeld" }, { name: "Ossendorf", slug: "ossendorf" }, { name: "Neuehrenfeld", slug: "neuehrenfeld" }],
    meta: { title: "Maler Köln-Bickendorf | Bodenständig | FarbWelt Service", description: "Ihr Maler in Bickendorf ✓ Fair ✓ Zuverlässig.", keywords: "Maler Bickendorf, Maler Köln-Bickendorf" }
  },

  ossendorf: {
    heroTitle: "Maler in Köln-Ossendorf – Wohnen und Gewerbe",
    heroSubtitle: "Professionelle Malerarbeiten in Ossendorf. Vom Eigenheim bis zum Büro.",
    mainContent: {
      intro: `Ossendorf ist bekannt für seine Mischung aus Wohngebieten und Gewerbe. Der Coloneum, Medienbetriebe und Handwerksfirmen prägen den Stadtteil neben den Wohnvierteln.`,
      localExpertise: `Wir arbeiten in Ossendorf sowohl für Privatkunden als auch für Gewerbebetriebe. Die Vielfalt macht es interessant.`,
      services: `Wohnungen, Häuser, Büros, Gewerberäume – alles aus einer Hand.`
    },
    faq: [{ question: "Arbeiten Sie auch für Gewerbebetriebe?", answer: "Ja, Büros und Gewerberäume gehören zu unserem Angebot." }],
    nearbyAreas: [{ name: "Bickendorf", slug: "bickendorf" }, { name: "Ehrenfeld", slug: "ehrenfeld" }, { name: "Nippes", slug: "nippes" }],
    meta: { title: "Maler Köln-Ossendorf | Wohnen & Gewerbe | FarbWelt Service", description: "Ihr Maler in Ossendorf ✓ Privat ✓ Gewerbe.", keywords: "Maler Ossendorf, Maler Köln-Ossendorf" }
  },

  braunsfeld: {
    heroTitle: "Maler in Köln-Braunsfeld – Gehobenes Wohnen im Westen",
    heroSubtitle: "Professionelle Malerarbeiten in der gehobenen Wohnlage Braunsfeld.",
    mainContent: {
      intro: `Braunsfeld gehört zu den gehobenen Wohnlagen im Kölner Westen. Die Nähe zum Stadtwald, die gute Infrastruktur und die ruhige Atmosphäre machen den Stadtteil attraktiv.`,
      localExpertise: `In Braunsfeld erwarten Kunden hohe Qualität. Die gepflegten Einfamilienhäuser und Wohnungen verdienen erstklassige Arbeit.`,
      services: `Premium-Malerarbeiten für anspruchsvolle Kunden – innen und außen.`
    },
    faq: [{ question: "Bieten Sie Premium-Qualität?", answer: "Ja, in Braunsfeld arbeiten wir auf höchstem Niveau." }],
    nearbyAreas: [{ name: "Lindenthal", slug: "lindenthal" }, { name: "Ehrenfeld", slug: "ehrenfeld" }, { name: "Junkersdorf", slug: "junkersdorf" }],
    meta: { title: "Maler Köln-Braunsfeld | Gehoben | FarbWelt Service", description: "Ihr Maler in Braunsfeld ✓ Premium ✓ Qualität.", keywords: "Maler Braunsfeld, Maler Köln-Braunsfeld" }
  },

  junkersdorf: {
    heroTitle: "Maler in Köln-Junkersdorf – Villen am Stadtwald",
    heroSubtitle: "Professionelle Malerarbeiten in der exklusiven Villenlage Junkersdorf.",
    mainContent: {
      intro: `Junkersdorf ist eine der besten Adressen im Kölner Westen. Die großzügigen Villen am Stadtwald, die ruhigen Straßen und die gepflegte Atmosphäre machen Junkersdorf zum begehrten Wohnort.`,
      localExpertise: `In Junkersdorf sind wir bei anspruchsvollen Projekten gefragt. Die Villen hier erfordern erstklassige Arbeit und individuelle Lösungen.`,
      services: `Villenrenovierung, Fassadensanierung, hochwertige Innenarbeiten – alles auf höchstem Niveau.`
    },
    faq: [{ question: "Haben Sie Erfahrung mit Villen?", answer: "Ja, wir arbeiten regelmäßig in Junkersdorf und kennen die Anforderungen." }],
    nearbyAreas: [{ name: "Braunsfeld", slug: "braunsfeld" }, { name: "Lindenthal", slug: "lindenthal" }, { name: "Weiden", slug: "weiden" }],
    meta: { title: "Maler Köln-Junkersdorf | Villen | FarbWelt Service", description: "Ihr Maler in Junkersdorf ✓ Villen ✓ Premium.", keywords: "Maler Junkersdorf, Maler Köln-Junkersdorf" }
  },

  weiden: {
    heroTitle: "Maler in Köln-Weiden – Ihr Partner am Stadtrand",
    heroSubtitle: "Professionelle Malerarbeiten in Weiden. Für Eigenheime und mehr.",
    mainContent: {
      intro: `Weiden liegt am westlichen Stadtrand von Köln. Der Stadtteil bietet Wohnen mit Platz und grüner Umgebung – ideal für Familien.`,
      localExpertise: `In Weiden dominieren Einfamilienhäuser und Reihenhäuser. Wir kennen die Anforderungen dieser Gebäudetypen.`,
      services: `Komplette Malerarbeiten für Eigenheime – innen und außen.`
    },
    faq: [{ question: "Arbeiten Sie auch am Stadtrand?", answer: "Ja, Weiden gehört zu unserem regulären Einzugsgebiet." }],
    nearbyAreas: [{ name: "Junkersdorf", slug: "junkersdorf" }, { name: "Lövenich", slug: "loevenich" }, { name: "Widdersdorf", slug: "widdersdorf" }],
    meta: { title: "Maler Köln-Weiden | Stadtrand | FarbWelt Service", description: "Ihr Maler in Weiden ✓ Eigenheim ✓ Lokal.", keywords: "Maler Weiden, Maler Köln-Weiden" }
  },

  loevenich: {
    heroTitle: "Maler in Köln-Lövenich – Dörflich und Modern",
    heroSubtitle: "Professionelle Malerarbeiten in Lövenich. Ihr lokaler Malerbetrieb.",
    mainContent: {
      intro: `Lövenich hat seinen dörflichen Charakter bewahrt und verbindet ihn mit modernem Wohnen. Neubaugebiete und traditionelle Bebauung ergänzen sich.`,
      localExpertise: `In Lövenich arbeiten wir sowohl in älteren Gebäuden als auch in Neubauten. Die Mischung macht es abwechslungsreich.`,
      services: `Alle Malerarbeiten für Eigenheime und Wohnungen – kompetent und fair.`
    },
    faq: [{ question: "Berechnen Sie Aufpreis für Lövenich?", answer: "Nein, Lövenich gehört zu Köln und damit zu unserem regulären Gebiet." }],
    nearbyAreas: [{ name: "Weiden", slug: "weiden" }, { name: "Widdersdorf", slug: "widdersdorf" }],
    meta: { title: "Maler Köln-Lövenich | Dörflich | FarbWelt Service", description: "Ihr Maler in Lövenich ✓ Lokal ✓ Fair.", keywords: "Maler Lövenich, Maler Köln-Lövenich" }
  },

  widdersdorf: {
    heroTitle: "Maler in Köln-Widdersdorf – Neues Wohnen im Westen",
    heroSubtitle: "Professionelle Malerarbeiten in Widdersdorf. Für Neubau und Bestand.",
    mainContent: {
      intro: `Widdersdorf ist eines der größten Neubaugebiete Kölns. Der Stadtteil wächst und bietet modernen Wohnraum für Familien. Neben den Neubauten gibt es auch den alten Ortskern mit seiner eigenen Atmosphäre.`,
      localExpertise: `In Widdersdorf sind wir mit Neubauten vertraut: Erstanstriche, Bauträger-Abwicklung, aber auch Renovierungen im Bestand.`,
      services: `Neubau-Erstanstrich, Renovierung, Fassadenarbeiten – für alle Bauphasen.`
    },
    faq: [{ question: "Arbeiten Sie mit Bauträgern?", answer: "Ja, wir führen Erstanstriche für Bauträger und Privatkunden durch." }],
    nearbyAreas: [{ name: "Lövenich", slug: "loevenich" }, { name: "Weiden", slug: "weiden" }],
    meta: { title: "Maler Köln-Widdersdorf | Neubau | FarbWelt Service", description: "Ihr Maler in Widdersdorf ✓ Neubau ✓ Erstanstrich.", keywords: "Maler Widdersdorf, Maler Köln-Widdersdorf" }
  }
};

export default seoContentKoeln3;
